module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.comicData) ? _c('div', [(this.$store.state.comicData.comic.is_locked) ? _c('div', [_c('h4', {
    staticClass: "comic-locked"
  }, [_vm._v("Time's up! You can no longer vote or comment on this comic."), _c('br'), _vm._v(" (Comic closed " + _vm._s(_vm.timer) + ")")])]) : _vm._e(), _vm._v(" "), (!this.$store.state.comicData.comic.is_locked && !this.$store.state.user) ? _c('div', [_c('h4', {
    staticClass: "not-logged-in"
  }, [_vm._v("\n      You must login to vote, comment, ask questions, and suggest what should happen next!\n      "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]) : _vm._e(), _vm._v(" "), (!this.$store.state.comicData.comic.is_locked && this.$store.state.user) ? _c('div', [_c('div', {
    staticClass: "row closing-time"
  }, [_c('p', [_vm._v("The comment time for this comic closes " + _vm._s(_vm.timer) + " (" + _vm._s(_vm.totalTime) + ")")])]), _vm._v(" "), _c('div', {
    class: {
      'row': true,
      'comic-post': true,
      'comic-post--new': true,
    }
  }, [(_vm.newPostError) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.newPostError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "comic-post-cell comic-post-cell--username comic-post-cell--username--new"
  }, [_vm._v("\n          " + _vm._s(this.$store.state.user.username) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "comic-post-cell comic-post-cell--text comic-post-cell--text--new"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostText),
      expression: "newPostText"
    }],
    staticClass: "input u-full-width comic-post-cell--text--new__input",
    attrs: {
      "id": "new-post-text",
      "placeholder": "What do you think?"
    },
    domProps: {
      "value": (_vm.newPostText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPostText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "comic-post-cell comic-post-cell--type--new"
  }, [_c('label', [_vm._v(" What kind of post is this?\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostType),
      expression: "newPostType"
    }],
    staticClass: "comic-post-cell--type",
    attrs: {
      "id": "new-post-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newPostType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(!_vm.userHasSuggestion) ? _c('option', {
    attrs: {
      "value": "suggestion",
      "selected": "selected"
    }
  }, [_vm._v("Suggest that this should happen next")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "question"
    }
  }, [_vm._v("Ask the author this as a question")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "comment"
    }
  }, [_vm._v("Just post this as a general comment")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "comic-post-cell comic-post-cell--submit"
  }, [_c('button', {
    staticClass: "comic-post-cell--submit__button button",
    on: {
      "click": _vm.sendPost
    }
  }, [_vm._v("Go!")])])])])]) : _vm._e(), _vm._v(" "), (this.$store.state.comicData.comic.is_locked && !this.$store.state.user) ? _c('div', [_c('h3', [_c('router-link', {
    staticClass: "button new-post-login",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" to leave a post or upvote one!\n    ")], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae7378ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewPost.vue
// module id = 282
// module chunks = 1